/**
 * @param {import('../../../../../../type-definitions').Refinement} refinement - refinement
 * @param {Array<import('../../../../../../type-definitions').Refinement>} cutOffRefinements - cut off refinements to show
 * @returns {string} "show more" refinements section HTML
 */
export default (refinement, cutOffRefinements) => {
    if (!refinement || cutOffRefinements?.length === 0) {
        return '';
    }

    return `
        <li class="refinement-dropdown refinement-dropdown-more">
            <div class="refinement-option-list toggle-content">
                <div class="dropdown-inner">
                    <ul class="values-list" aria-label="${refinement.name} ${window.Resources.SEARCH_FILTER}">
                        ${cutOffRefinements.join('')}
                    </ul>
                </div>
            </div>
            <button class="refinement-select toggle show-more">
                <div class="refinement-select-inner">
                    <span class="toggle-label toggle-label-more" aria-hidden="false" aria-label="${
                        window.Resources.SHOW_MORE
                    }">
                        ${window.Resources.SHOW_MORE}
                    </span>
                    <span class="toggle-label toggle-label-less" aria-hidden="true" aria-label="${
                        window.Resources.SHOW_LESS
                    }">
                        ${window.Resources.SHOW_LESS}
                    </span>
                </div>
            </button>
        </li>
    `;
};
